export default __webpack_public_path__ + "static/wsl-docker-start-0e03804a12337dfcfd781404a0e4f986.webp";